module.exports = __webpack_public_path__ + "img/reveal-ape-traits.1deffa7b.webp";